export default "__VITE_ASSET__DGLllzUa__"